export default {"src":"/_next/static/media/reading-map.colour.c912c5a2.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};